import produce from 'immer';

import type { Action } from 'Lib/reduxType';

import { CAPTCHA_VERIFY_FAILURE } from 'Store/captcha/constants';
import {
  PURCHASE_3D_ERROR_RESPONSE,
  PURCHASE_CLEAR_ERROR_RESPONSE,
  PURCHASE_ERROR_RESPONSE,
  PURCHASE_RESTORE_ACCOUNT_CLEAR_ERROR_RESPONSE,
  PURCHASE_RESTORE_ACCOUNT_ERROR_RESPONSE,
  PURCHASE_UPDATE_EMAIL_CLEAR_ERROR_RESPONSE,
  PURCHASE_UPDATE_EMAIL_ERROR_RESPONSE,
  PURCHASE_UPDATE_LATEST_CARD_CLEAR_ERR_RESPONSE,
  PURCHASE_UPDATE_LATEST_CARD_ERR_RESPONSE,
} from 'Store/purchase/constants';

import initialState from './initialState';
import type { ErrorsState } from './types';

export const reducer = produce<ErrorsState, [Action]>((draft, action) => {
  switch (action.type) {
    case CAPTCHA_VERIFY_FAILURE:
      draft.captchaVerificationError = action.payload;
      break;
    case PURCHASE_ERROR_RESPONSE:
    case PURCHASE_3D_ERROR_RESPONSE:
      draft.paymentFailureError = action.payload;
      break;
    case PURCHASE_CLEAR_ERROR_RESPONSE:
      draft.paymentFailureError = null;
      break;
    case PURCHASE_UPDATE_LATEST_CARD_ERR_RESPONSE:
      draft.paymentUpdateCardError = action.payload;
      break;
    case PURCHASE_UPDATE_LATEST_CARD_CLEAR_ERR_RESPONSE:
      draft.paymentUpdateCardError = null;
      break;
    case PURCHASE_RESTORE_ACCOUNT_ERROR_RESPONSE: {
      // @TODO, revenue team check what is the correct response here
      const restoreAccountError = {
        tag: 'generic',
        code: 0,
      };
      draft.restoreAccountError = restoreAccountError;
      break;
    }
    case PURCHASE_RESTORE_ACCOUNT_CLEAR_ERROR_RESPONSE:
      draft.restoreAccountError = null;
      break;
    case PURCHASE_UPDATE_EMAIL_ERROR_RESPONSE:
      draft.updateEmailError = true;
      break;
    case PURCHASE_UPDATE_EMAIL_CLEAR_ERROR_RESPONSE:
      draft.updateEmailError = null;
      break;
  }
}, initialState);

export default reducer;
